export const environment = {
  production: true,
  url_api: 'https://eventostudociclismo-gkaaataqhtfcgrdv.brazilsouth-01.azurewebsites.net/',
  url_api_site: 'https://tudociclismo.com.br/API/',
  url_api_asp: 'https://webtudociclismo-c0b2g4bfcwhvbgbb.brazilsouth-01.azurewebsites.net/',
  url_site: 'https://tudociclismo.com.br',
  ga4MeasurementId: 'G-BD1D46VT0L'
};
